const config = {
    apiUrl: process.env.VUE_APP_ROOT_API,
    campaignBaseUrl: (process.env.VUE_APP_CAMPAIGN_BASE_URL || 'https://rd365.app').replace(/\/$/, '')
}

/**
 * Prefer the user's custom domain when set; otherwise platform campaign URL.
 * @param { { domain?: string|null } | null | undefined } user
 */
export function resolveCampaignBaseUrl(user) {
    const raw = (user && user.domain ? String(user.domain) : '').trim();
    if (!raw) return config.campaignBaseUrl;

    let host = raw.replace(/^https?:\/\//i, '');
    host = host.split('/')[0];
    host = host.split(':')[0];
    if (host.toLowerCase().startsWith('www.')) {
        host = host.slice(4);
    }
    host = host.trim().toLowerCase();
    if (!host) return config.campaignBaseUrl;

    return `https://${host}`;
}

/**
 * @param {string} slug
 * @param { { domain?: string|null } | null | undefined } user
 */
export function buildCampaignPublicUrl(slug, user) {
    return `${resolveCampaignBaseUrl(user)}/c/${slug}`;
}

export default config;
